import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';

@Component({
    selector: 'app-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss'],
    imports: [
    NgTemplateOutlet
]
})
export class DialogComponent {
  @Input() open: boolean = false;

  /**
   * Optional template to render inside the dialog.
   * If not provided, consumers can use content projection via <ng-content>.
   */
  @Input() contentTemplate: any | null = null;

  @Output() closed = new EventEmitter<void>();

  @HostListener('document:keydown.escape', ['$event'])
  handleEscape(_event: Event) {
    if (!this.open) {
      return;
    }
    this.close();
  }

  close(): void {
    this.closed.emit();
  }
}

